/**
 * Created by jmulder on 18/10/16.
 */


export class AgendaItem {

  constructor(
    public day: number,
    public tenantId: number,
    public index: number,
    public court: number,
    public startTime: string,   // local time as HH:MM
    public name?: string,
    public duration?: number,    // time in seconds
    public type?: string,
    public endTime?: string,     // local time as HH:MM
    public clubId?: string
  ) {

  }

  static toAgendaItem(day: number, tenantId: number, index: number, r:any): AgendaItem {
    let item = new AgendaItem( day, tenantId, index, r.court, r.startTime, r.name, r.duration, r.type, r.endTime, r.clubId );
    return item;
  }

}
